// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: tTrZUA2D1LT
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Sidebar from "../../Sidebar"; // plasmic-import: KsLZ7sb8Ji8/component
import SearchRectangle from "../../SearchRectangle"; // plasmic-import: xSJM4Lfdlu/component
import InvoiceFields from "../../InvoiceFields"; // plasmic-import: hJIBO7YIKt/component
import AdvancedOptionsComponent from "../../AdvancedOptionsComponent"; // plasmic-import: FhZFNoyzlv/component
import Switch from "../../Switch"; // plasmic-import: gp-QRljuykd/component
import AutomationSelect from "../../AutomationSelect"; // plasmic-import: F7BYn5PzZSi/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicInvoiceDetails2.module.css"; // plasmic-import: tTrZUA2D1LT/css

createPlasmicElementProxy;

export const PlasmicInvoiceDetails2__VariantProps = new Array();

export const PlasmicInvoiceDetails2__ArgProps = new Array("balanceDue2");

const $$ = {};

function PlasmicInvoiceDetails2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "achSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "cardSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "wireSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => "isChecked"
      },
      {
        path: "recurringInvoicesSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "paymentReminderSwitch.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "recurringEscrowSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "paymentReminderSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__ajiwS)}>
            <div className={classNames(projectcss.all, sty.freeBox__n22Xh)}>
              <p.Stack
                as={"div"}
                data-plasmic-name={"invoiceDetails"}
                data-plasmic-override={overrides.invoiceDetails}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__pzNmS)}>
                  <div
                    data-plasmic-name={"title4"}
                    data-plasmic-override={overrides.title4}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title4
                    )}
                  >
                    {"Invoice Details"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"title3"}
                  data-plasmic-override={overrides.title3}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title3
                  )}
                >
                  {"Client"}
                </div>
                <SearchRectangle
                  data-plasmic-name={"searchRectangle"}
                  data-plasmic-override={overrides.searchRectangle}
                  className={classNames("__wab_instance", sty.searchRectangle)}
                />

                <div
                  data-plasmic-name={"title8"}
                  data-plasmic-override={overrides.title8}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title8
                  )}
                >
                  {"Invoice Due Date"}
                </div>
                <div
                  data-plasmic-name={"dueDate"}
                  data-plasmic-override={overrides.dueDate}
                  className={classNames(projectcss.all, sty.dueDate)}
                />
              </p.Stack>
              <p.Stack
                as={"div"}
                data-plasmic-name={"invoiceDetails2"}
                data-plasmic-override={overrides.invoiceDetails2}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails2)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__gJd)}>
                  <div
                    data-plasmic-name={"title5"}
                    data-plasmic-override={overrides.title5}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title5
                    )}
                  >
                    {"Payment Details"}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__lfl8Y)}>
                  <div
                    data-plasmic-name={"title13"}
                    data-plasmic-override={overrides.title13}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title13
                    )}
                  >
                    {"Item"}
                  </div>
                  <div
                    data-plasmic-name={"title14"}
                    data-plasmic-override={overrides.title14}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title14
                    )}
                  >
                    {"Quantity"}
                  </div>
                  <div
                    data-plasmic-name={"title15"}
                    data-plasmic-override={overrides.title15}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title15
                    )}
                  >
                    {"Pricing"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"invoiceStack2"}
                  data-plasmic-override={overrides.invoiceStack2}
                  className={classNames(projectcss.all, sty.invoiceStack2)}
                >
                  <InvoiceFields
                    data-plasmic-name={"invoiceFields"}
                    data-plasmic-override={overrides.invoiceFields}
                    className={classNames("__wab_instance", sty.invoiceFields)}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__iBsWc)}>
                  <div
                    data-plasmic-name={"addItem2"}
                    data-plasmic-override={overrides.addItem2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.addItem2
                    )}
                  >
                    {"Add Item"}
                  </div>
                  <div
                    data-plasmic-name={"title16"}
                    data-plasmic-override={overrides.title16}
                    className={classNames(projectcss.all, sty.title16)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "Balance Due: $0",
                      value: args.balanceDue2,
                      className: classNames(sty.slotTargetBalanceDue2)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"title17"}
                  data-plasmic-override={overrides.title17}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title17
                  )}
                >
                  {"Notes/Terms (optional)"}
                </div>
                <textarea
                  data-plasmic-name={"notes2"}
                  data-plasmic-override={overrides.notes2}
                  className={classNames(
                    projectcss.all,
                    projectcss.textarea,
                    sty.notes2
                  )}
                  ref={ref => {
                    $refs["notes2"] = ref;
                  }}
                  value={""}
                />
              </p.Stack>
              <div className={classNames(projectcss.all, sty.freeBox__lMg6I)}>
                <AdvancedOptionsComponent
                  data-plasmic-name={"advancedOptionsInstance"}
                  data-plasmic-override={overrides.advancedOptionsInstance}
                  className={classNames(
                    "__wab_instance",
                    sty.advancedOptionsInstance
                  )}
                />

                <div
                  data-plasmic-name={"advancedOptionsStack"}
                  data-plasmic-override={overrides.advancedOptionsStack}
                  className={classNames(
                    projectcss.all,
                    sty.advancedOptionsStack
                  )}
                >
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__srhAf)}
                  >
                    <div
                      data-plasmic-name={"title26"}
                      data-plasmic-override={overrides.title26}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title26
                      )}
                    >
                      {"Payment Methods"}
                    </div>
                    <Switch
                      data-plasmic-name={"achSwitch"}
                      data-plasmic-override={overrides.achSwitch}
                      className={classNames("__wab_instance", sty.achSwitch)}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "achSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "achSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__wIdEv
                        )}
                      >
                        {"ACH"}
                      </div>
                    </Switch>
                    <Switch
                      data-plasmic-name={"cardSwitch"}
                      data-plasmic-override={overrides.cardSwitch}
                      className={classNames("__wab_instance", sty.cardSwitch)}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "cardSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "cardSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__cVhaJ
                        )}
                      >
                        {"Card"}
                      </div>
                    </Switch>
                    <Switch
                      data-plasmic-name={"wireSwitch"}
                      data-plasmic-override={overrides.wireSwitch}
                      className={classNames("__wab_instance", sty.wireSwitch)}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "wireSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "wireSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__l87Mx
                        )}
                      >
                        {"Wire"}
                      </div>
                    </Switch>
                  </p.Stack>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__fF5Z)}
                  >
                    <div
                      data-plasmic-name={"title28"}
                      data-plasmic-override={overrides.title28}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title28
                      )}
                    >
                      {"Automation Options"}
                    </div>
                    <Switch
                      data-plasmic-name={"recurringInvoicesSwitch"}
                      data-plasmic-override={overrides.recurringInvoicesSwitch}
                      className={classNames(
                        "__wab_instance",
                        sty.recurringInvoicesSwitch
                      )}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "recurringInvoicesSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "recurringInvoicesSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__br3Y0
                        )}
                      >
                        {"Recurring Invoices"}
                      </div>
                    </Switch>
                    <div
                      data-plasmic-name={"recurringInvoiceStack"}
                      data-plasmic-override={overrides.recurringInvoiceStack}
                      className={classNames(
                        projectcss.all,
                        sty.recurringInvoiceStack
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__twSvk
                        )}
                      >
                        {"Every:"}
                      </div>
                      <input
                        data-plasmic-name={"recurringNumber"}
                        data-plasmic-override={overrides.recurringNumber}
                        className={classNames(
                          projectcss.all,
                          projectcss.input,
                          sty.recurringNumber
                        )}
                        placeholder={"0"}
                        ref={ref => {
                          $refs["recurringNumber"] = ref;
                        }}
                        size={1}
                        type={"number"}
                        value={""}
                      />

                      <AutomationSelect
                        data-plasmic-name={"recurringEscrowSelect"}
                        data-plasmic-override={overrides.recurringEscrowSelect}
                        className={classNames(
                          "__wab_instance",
                          sty.recurringEscrowSelect
                        )}
                        onChange={(...eventArgs) => {
                          p.generateStateOnChangeProp($state, [
                            "recurringEscrowSelect",
                            "value"
                          ])(eventArgs[0]);
                        }}
                        placeholder={"Select"}
                        value={p.generateStateValueProp($state, [
                          "recurringEscrowSelect",
                          "value"
                        ])}
                      />
                    </div>
                  </p.Stack>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__vNhKc)}
                  >
                    <div
                      data-plasmic-name={"title27"}
                      data-plasmic-override={overrides.title27}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.title27
                      )}
                    >
                      {hasVariant(globalVariants, "screen", "medium")
                        ? "Payment Reminders"
                        : "Payment Reminders"}
                    </div>
                    <Switch
                      data-plasmic-name={"paymentReminderSwitch"}
                      data-plasmic-override={overrides.paymentReminderSwitch}
                      className={classNames(
                        "__wab_instance",
                        sty.paymentReminderSwitch
                      )}
                      isChecked={
                        p.generateStateValueProp($state, [
                          "paymentReminderSwitch",
                          "isChecked"
                        ]) ?? false
                      }
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "paymentReminderSwitch",
                          "isChecked"
                        ])(eventArgs[0]);
                      }}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__lNzpb
                        )}
                      >
                        {"Payment Reminder Notifications"}
                      </div>
                    </Switch>
                    <div
                      data-plasmic-name={"paymentReminderStack"}
                      data-plasmic-override={overrides.paymentReminderStack}
                      className={classNames(
                        projectcss.all,
                        sty.paymentReminderStack
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__cxJkk
                        )}
                      >
                        {"Every:"}
                      </div>
                      <input
                        data-plasmic-name={"reminderNumber"}
                        data-plasmic-override={overrides.reminderNumber}
                        className={classNames(
                          projectcss.all,
                          projectcss.input,
                          sty.reminderNumber
                        )}
                        placeholder={"0"}
                        ref={ref => {
                          $refs["reminderNumber"] = ref;
                        }}
                        size={1}
                        type={"number"}
                        value={""}
                      />

                      <AutomationSelect
                        data-plasmic-name={"paymentReminderSelect"}
                        data-plasmic-override={overrides.paymentReminderSelect}
                        className={classNames(
                          "__wab_instance",
                          sty.paymentReminderSelect
                        )}
                        onChange={(...eventArgs) => {
                          p.generateStateOnChangeProp($state, [
                            "paymentReminderSelect",
                            "value"
                          ])(eventArgs[0]);
                        }}
                        placeholder={"Select"}
                        value={p.generateStateValueProp($state, [
                          "paymentReminderSelect",
                          "value"
                        ])}
                      />
                    </div>
                  </p.Stack>
                </div>
              </div>
              <div
                data-plasmic-name={"sendButton"}
                data-plasmic-override={overrides.sendButton}
                className={classNames(projectcss.all, sty.sendButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__tfh8Z
                  )}
                >
                  {hasVariant(globalVariants, "screen", "medium")
                    ? "Review and Send"
                    : "Review and Send"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "invoiceDetails",
    "title4",
    "title3",
    "searchRectangle",
    "title8",
    "dueDate",
    "invoiceDetails2",
    "title5",
    "title13",
    "title14",
    "title15",
    "invoiceStack2",
    "invoiceFields",
    "addItem2",
    "title16",
    "title17",
    "notes2",
    "advancedOptionsInstance",
    "advancedOptionsStack",
    "title26",
    "achSwitch",
    "cardSwitch",
    "wireSwitch",
    "title28",
    "recurringInvoicesSwitch",
    "recurringInvoiceStack",
    "recurringNumber",
    "recurringEscrowSelect",
    "title27",
    "paymentReminderSwitch",
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect",
    "sendButton"
  ],

  sidebar: ["sidebar"],
  invoiceDetails: [
    "invoiceDetails",
    "title4",
    "title3",
    "searchRectangle",
    "title8",
    "dueDate"
  ],

  title4: ["title4"],
  title3: ["title3"],
  searchRectangle: ["searchRectangle"],
  title8: ["title8"],
  dueDate: ["dueDate"],
  invoiceDetails2: [
    "invoiceDetails2",
    "title5",
    "title13",
    "title14",
    "title15",
    "invoiceStack2",
    "invoiceFields",
    "addItem2",
    "title16",
    "title17",
    "notes2"
  ],

  title5: ["title5"],
  title13: ["title13"],
  title14: ["title14"],
  title15: ["title15"],
  invoiceStack2: ["invoiceStack2", "invoiceFields"],
  invoiceFields: ["invoiceFields"],
  addItem2: ["addItem2"],
  title16: ["title16"],
  title17: ["title17"],
  notes2: ["notes2"],
  advancedOptionsInstance: ["advancedOptionsInstance"],
  advancedOptionsStack: [
    "advancedOptionsStack",
    "title26",
    "achSwitch",
    "cardSwitch",
    "wireSwitch",
    "title28",
    "recurringInvoicesSwitch",
    "recurringInvoiceStack",
    "recurringNumber",
    "recurringEscrowSelect",
    "title27",
    "paymentReminderSwitch",
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect"
  ],

  title26: ["title26"],
  achSwitch: ["achSwitch"],
  cardSwitch: ["cardSwitch"],
  wireSwitch: ["wireSwitch"],
  title28: ["title28"],
  recurringInvoicesSwitch: ["recurringInvoicesSwitch"],
  recurringInvoiceStack: [
    "recurringInvoiceStack",
    "recurringNumber",
    "recurringEscrowSelect"
  ],

  recurringNumber: ["recurringNumber"],
  recurringEscrowSelect: ["recurringEscrowSelect"],
  title27: ["title27"],
  paymentReminderSwitch: ["paymentReminderSwitch"],
  paymentReminderStack: [
    "paymentReminderStack",
    "reminderNumber",
    "paymentReminderSelect"
  ],

  reminderNumber: ["reminderNumber"],
  paymentReminderSelect: ["paymentReminderSelect"],
  sendButton: ["sendButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInvoiceDetails2__ArgProps,
          internalVariantPropNames: PlasmicInvoiceDetails2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInvoiceDetails2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInvoiceDetails2";
  } else {
    func.displayName = `PlasmicInvoiceDetails2.${nodeName}`;
  }
  return func;
}

export const PlasmicInvoiceDetails2 = Object.assign(
  // Top-level PlasmicInvoiceDetails2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    invoiceDetails: makeNodeComponent("invoiceDetails"),
    title4: makeNodeComponent("title4"),
    title3: makeNodeComponent("title3"),
    searchRectangle: makeNodeComponent("searchRectangle"),
    title8: makeNodeComponent("title8"),
    dueDate: makeNodeComponent("dueDate"),
    invoiceDetails2: makeNodeComponent("invoiceDetails2"),
    title5: makeNodeComponent("title5"),
    title13: makeNodeComponent("title13"),
    title14: makeNodeComponent("title14"),
    title15: makeNodeComponent("title15"),
    invoiceStack2: makeNodeComponent("invoiceStack2"),
    invoiceFields: makeNodeComponent("invoiceFields"),
    addItem2: makeNodeComponent("addItem2"),
    title16: makeNodeComponent("title16"),
    title17: makeNodeComponent("title17"),
    notes2: makeNodeComponent("notes2"),
    advancedOptionsInstance: makeNodeComponent("advancedOptionsInstance"),
    advancedOptionsStack: makeNodeComponent("advancedOptionsStack"),
    title26: makeNodeComponent("title26"),
    achSwitch: makeNodeComponent("achSwitch"),
    cardSwitch: makeNodeComponent("cardSwitch"),
    wireSwitch: makeNodeComponent("wireSwitch"),
    title28: makeNodeComponent("title28"),
    recurringInvoicesSwitch: makeNodeComponent("recurringInvoicesSwitch"),
    recurringInvoiceStack: makeNodeComponent("recurringInvoiceStack"),
    recurringNumber: makeNodeComponent("recurringNumber"),
    recurringEscrowSelect: makeNodeComponent("recurringEscrowSelect"),
    title27: makeNodeComponent("title27"),
    paymentReminderSwitch: makeNodeComponent("paymentReminderSwitch"),
    paymentReminderStack: makeNodeComponent("paymentReminderStack"),
    reminderNumber: makeNodeComponent("reminderNumber"),
    paymentReminderSelect: makeNodeComponent("paymentReminderSelect"),
    sendButton: makeNodeComponent("sendButton"),
    // Metadata about props expected for PlasmicInvoiceDetails2
    internalVariantProps: PlasmicInvoiceDetails2__VariantProps,
    internalArgProps: PlasmicInvoiceDetails2__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicInvoiceDetails2;
/* prettier-ignore-end */
